import Vue from "vue";
import * as Api from "../../axios-generated/backoffice";
// @ts-ignore
import axios from "@axios";

const SUBSCRIPTIONS_API = new Api.SubscriptionsApi(
  undefined,
  Vue.prototype.$config.VUE_APP_BACKOFFICE_API_BASE_URL,
  axios
);

export default {
  namespaced: true,
  state: {},
  getters: {},
  mutations: {},
  actions: {
    findFlowsBySubscriptionID(ctx, queryParams) {
      return new Promise((resolve, reject) => {
        SUBSCRIPTIONS_API.findFlowsBySubscriptionID(
          queryParams.subscriptionID,
          queryParams.sortBy,
          queryParams.perPage,
          queryParams.page,
          queryParams.sortDesc
        )
          .then((response) => resolve(response))
          .catch((error) => reject(error));
      });
    },
  },
};
